import { useContext, useState, useEffect, useRef } from 'react';
import { HttpContext } from '../../api-services/HttpService';
import AutoCompleteInput from './AutoCompleteInputCopy.jsx';
import UploadS3ExcelButton from './UploadS3ExcelButtonCopy.jsx';
import PageContext from './PageContext'; 
import MonthPicker from './MonthPickerCopy.jsx';
import AutoCompleteInputWithFunc from './AutoCompleteInputWithFunc';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';
import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';
import ArrowUpwardIcon from '../../svgs/uparrow.svg';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import getRandomInt from '../functions/getRandomInt.js';
import BannerAlert from './BannerAlertCopy.jsx';
import FileDropZone from './FileDropZone.jsx';

// prototype to get periodid (YYYYMM) date string
Date.prototype.getPeriodId = function() {
    let mm = this.getMonth() + 1; // getMonth() is zero-based
  
    return [
        this.getFullYear(),
        (mm > 9 ? '' : '0') + mm
    ].join('');
};

// get string of timestamp for filename
Date.prototype.getFileTimestamp = function(){
    let MM = this.getMonth() + 1; // getMonth() is zero-based
    let dd = this.getDate();
    let hh = this.getHours(); 
    let mm = this.getMinutes(); 
    let ss = this.getSeconds(); 

    return [
        this.getFullYear(),
        (MM > 9 ? '' : '0') + MM,
        (dd > 9 ? '' : '0') + dd, 
        (hh > 9 ? '' : '0') + hh, 
        (mm > 9 ? '' : '0') + mm, 
        (ss > 9 ? '' : '0') + ss, 
    ].join('');
}

const AddClienttContractSearchIdModal = () => {
    // get context from parent
    const {
        uploadClientContractModal, 
        setUploadClientContractModal,
        snackbarAlert, 
        refreshContractUpload, 
        masterCompanyList, 
    } = useContext(PageContext);
    // get http context
    const {
        PUT, 
        GET, 
    } = useContext(HttpContext); 
    // intiailize state
    const [masterCompanyId, setMasterCompanyId] = useState(null); 
    const [masterCompanyObj, setMasterCompanyObj] = useState({label: '', id: ''});  
    const [subCompanyId, setSubCompanyId] = useState(''); 
    const [startPeriodId, setStartPeriodId] = useState(new Date()); 
    const [endPeriodId, setEndPeriodId] = useState(new Date()); 
    const [comment, setComment] = useState(''); 
    const [subCompanyList, setSubCompanyList] = useState([]); 
    // initialize refs for file
    const contractFile = useRef(); 
    const contractFileInput = useRef();    
    // const uploadFileName = useRef('');
    const [uploadFileName, setUploadFileName] = useState(''); 
    // initialize ref for initial render
    const initialRender = useRef(true);    
    const [fileSelected, setFileSelected] = useState(false)

    // handle contract file change
    const onContractFileChange = (e) => {
        if(e.target.files.length > 0){
            setFileSelected(true);
        }
        console.log(e); 
        // set file 
        contractFile.current = e.target.files[0];

        // update file name in case of multiple uploads in a row 
        let today = new Date();
        let random = getRandomInt(4);  
        console.log('CHANGE: ', 'Contract_' + masterCompanyId + '_'+ subCompanyId + '_' + today.getFileTimestamp() + '_' + random.toString() + '.pdf'); 
        setUploadFileName(uploadFileName => uploadFileName = 'Contract_' + masterCompanyId + '_'+ subCompanyId + '_' + today.getFileTimestamp() + '_' + random.toString() + '.pdf'); 
    }

    // handle drag and drop file
    const onFileDrop = (file) => {
        contractFile.current = file;
        setFileSelected(true);
        let today = new Date();
        let random = getRandomInt(4);
        setUploadFileName('Contract_' + masterCompanyId + '_' + subCompanyId + '_' + today.getFileTimestamp() + '_' + random.toString() + '.pdf');
    }

    // event handler for value change in commment textarea
    const onTextAreaChange = (e) =>{
        // set state to value passed in event object
        setComment(comment => comment = e.target.value);
    }

    // validations before uploading contract
    const validateData = () => {
        // check that master company ID is valid 
        if (masterCompanyId == null || masterCompanyId != masterCompanyObj['id']) {
            snackbarAlert(true, 'Invalid master company ID.', 'error');
            return false; 
        }
        // check that sub company ID is valid
        if (!subCompanyList.includes(subCompanyId)){
            snackbarAlert(true, 'Invalid company ID.', 'error'); 
            return false; 
        }
        // check that startPeriodId and endPeriodId are in correct order
        if (startPeriodId > endPeriodId){
            snackbarAlert(true, 'Invalid start and end periods.', 'error'); 
            return false;
        }
        // check for valid comment
        if (comment.length <= 0){
            snackbarAlert(true, 'Please input valid comment.', 'error'); 
            return false;
        } 
        // return true
        return true; 
    }
    
    // handle contract pdf click event 
    const putContractMetadata = () => {
        return new Promise((resolve, reject) => {
            PUT('/data/uploadClientContract', {
                mastercompanyid: masterCompanyId, 
                companyid: subCompanyId, 
                startperiodid: startPeriodId.getPeriodId(), 
                endperiodid: endPeriodId.getPeriodId(), 
                contractcomment: comment, 
                uploadfilename: uploadFileName, 
                displayfilename: contractFile.current.name, 
            }).then(res => { 
                // resolve on success
                resolve(res); 
            }).catch(err => {
                reject(err); 
            });
        });  
    }

    // refresh data on page table 
    const refreshTableData = () => {
        return new Promise((resolve, reject) => {
            // default all values 
            setMasterCompanyObj(masterCompanyObj => masterCompanyObj = {label: '', id: ''}); 
            // hide modals
            setUploadClientContractModal(uploadClientContractModal => uploadClientContractModal = false); 
            // use function to refresh table data
            refreshContractUpload().then(res => {
                resolve(res); 
            }).catch(err => {
                reject(err); 
            }); 
        }); 
    }

    // get subCompanyList from api 
    const getSubCompanyList = (masterCompanyObj) => {
        return new Promise((resolve, reject) => {
            GET('/data/searchClientContractsPage/subCompanyList', {
                mastercompanyid: masterCompanyObj['id'], 
            }).then(res => {
                // set sub company list 
                if (process.env.REACT_APP_CONTRACT_AT_MASTER_COMPANY_LEVEL === '1') {
                    setSubCompanyList(subCompanyList => subCompanyList = ['All']);  
                }
                else {
                    setSubCompanyList(subCompanyList => subCompanyList = res['data']['SubCompanyList']); 
                }
                // set master company id 
                setMasterCompanyId(masterCompanyId => masterCompanyId = res['data']['MasterCompanyId']); 
                // resolve on success
                resolve(res); 
            }).catch(err => {
                // nullify master company id on error
                setMasterCompanyId(masterCompanyId => masterCompanyId = null); 
                // reject on error
                reject(err); 
            }); 
        });  
    }

    // useEffect to default all values on masterCompanyObj change
    useEffect(() => {   
        if (initialRender.current == false){
            // reset metadata inputs
            setMasterCompanyId(masterCompanyId => masterCompanyId = null); 
            setSubCompanyList(subCompanyList => subCompanyList = []); 
            setSubCompanyId(subCompanyId => subCompanyId = ''); 
            setStartPeriodId(startPeriodId => startPeriodId = new Date()); 
            setEndPeriodId(endPeriodId => endPeriodId = new Date()); 
            setComment(comment => comment = ''); 
            // reset fileInput 
            if (contractFileInput.current != null && contractFileInput.current.value != null){
                contractFileInput.current.value = '';
            }
            if (contractFile.current != null){
                contractFile.current = null; 
            }
            setFileSelected(false);
        }
        else {
            initialRender.current = false; 
        }
    }, [masterCompanyObj]); 

    const resetFileInput = () => {
        if (contractFileInput.current != null && contractFileInput.current.value != null){
            contractFileInput.current.value = '';
        }
        if (contractFile.current != null){
            contractFile.current = null; 
        }
        setFileSelected(false);
    }

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: '1'
    })

    const StyledButton = styled(Button) ({
        backgroundColor: '#185230',
        color: "#FFFFFF",
        borderRadius: '20px',
        padding: '6px 16px',
        textTransform: 'none',
        fontWeight: '500',
        fontFamily: 'Roboto medium',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: '#185230'
        }
    })

    return (
        <>
            <CCOffcanvas
                title='Add Client Contract'
                show={uploadClientContractModal}
                onCanvasClose={()=>{setUploadClientContractModal(uploadClientContractModal => uploadClientContractModal = false); }}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-3"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        <div >
                        <AutoCompleteInputWithFunc tag='Master Company' obj={masterCompanyObj} setObj={setMasterCompanyObj} func={getSubCompanyList} list={masterCompanyList} width={'100%'} topAlignTypography={true}/>
                        </div>
                        <div>
                        <AutoCompleteInput tag='Company ID' value={subCompanyId} setValue={setSubCompanyId} list={subCompanyList} width={'100%'} topAlignTypography={true}/>
                        </div>
                        <div >
                            <MonthPicker topAlignTypography={true} tag='Start Period' value={startPeriodId} setValue={setStartPeriodId} width={'100%'}/>
                        </div>
                        <div >
                            <MonthPicker topAlignTypography={true} tag='End Period' value={endPeriodId} setValue={setEndPeriodId} width={'100%'}/>
                        </div> 
                        <div >
                            <div>Contract Description</div>
                            <textarea class='modal-text-area' value={comment} onChange={(e)=>onTextAreaChange(e)}></textarea>
                        </div>
                       
                        <div>
                            <div className='mb-3'>Choose Client Contract File</div>
                            <FileDropZone onFileDrop={onFileDrop} accept='.pdf'>
                                <StyledButton component="label" role={undefined} tabIndex={-1} endIcon={fileSelected ? <CheckIcon /> : <img src={ArrowUpwardIcon} />}>
                                    {fileSelected ? 'File Selected' : 'Browse'}
                                    <VisuallyHiddenInput type='file' accept='.pdf' onChange={onContractFileChange} ref={ref => contractFileInput.current = ref} />
                                </StyledButton>
                                <div className='d-flex mt-3'>
                                    {fileSelected && contractFile ? contractFile?.current?.name : null}
                                    {fileSelected && contractFile ? <CloseIcon sx={{ color: 'red', width: '18px', marginLeft: '1rem' }} onClick={() => { setUploadFileName(""); setFileSelected(false); }} /> : null}
                                </div>
                            </FileDropZone>
                        </div>
                                                        
                    </div>
                    <div>
                        <BannerAlert show={true} message={'Do not close slider or navigate away from page while uploading file.'} type='warning' disableClose={true} />
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"}
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                            onButtonClick={() => {setUploadClientContractModal(uploadClientContractModal => uploadClientContractModal = false); }}
                        />
                        <UploadS3ExcelButton tag='Upload PDF' folder='contracts/initial/' filename={uploadFileName} file={contractFile} fileInput={contractFileInput} resetFileInput={resetFileInput} putMetadata={putContractMetadata} refreshData={refreshTableData} validateData={validateData} snackbarAlert={snackbarAlert} css='modal-button-full-blue-upload' showSpinner={false}/>
                    </div>
                </div>
            </CCOffcanvas>
        </>
    ); 

}

export default AddClienttContractSearchIdModal; 